<template>
  <div>
    <div class="input-field col s12 offset-m1 m10 offset-l3 l6">
      <h3>Jelszó beállítása</h3>
    </div>
    <div class="row">
      <div v-show="!error" class="input-field col s12 offset-m1 m10 offset-l3 l6">
        Feldolgozás...
      </div>
      <div v-show="error" class="input-field col s12 offset-m1 m10 offset-l3 l6">
        <i class="large material-icons lockImageStyle">lock</i>
        <br/>
        <div>
          Ez a link érvénytelen. A link érvénytelenségének okai lehetnek például:
          <ul class="criteria">
            <li>letelt az időkorlát, vagy</li>
            <li>már egyszer megnyitotta ezt a linket, vagy</li>
            <li>rosszul másolta be a linket a böngésző címsorába.</li>
          </ul>
        </div><br/>
        <div class="forgotPassword">
          <a v-link="{ path: '/' }">Vissza a kezdőoldalra</a><br/>
          <a v-link="{ path: 'forgot-password' }">
            Új jelszó-beállító email igénylése
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'material-design-icons-iconfont/dist/material-design-icons.scss'
import urlencode from 'urlencode'
import {post} from '../../api'
import db from '../../db'

export default {
  data() {
    return {
      error: false
    }
  },
  ready() {
    const vm = this
    const username = this.$route.query.user
    const usernameDecoded = urlencode.decode(username)
    const genpass = this.$route.query.id

    if (!username || !genpass) {
      this.error = true
      return
    }

    post('/public/ajax/login', {username: usernameDecoded, password: genpass}, (res) => {
      if (res.user) {
        db.set('user', res.user)
        window.location.href = '/'
      } else {
        this.error = true
      }
    }, {
      error: function(xhr, textStatus, errorThrown) {
        vm.error = true
      }
    }, false)
  }
}
</script>

<style>
.criteria li {
  margin-left: 20px;
  list-style-type: circle;
}

.lockImageStyle {
  margin-left: 40%;
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?18d274ac